/**
 * Powers the Global Notes page. Returns the distinct entities that own at
 * least one note, with aggregate counts + last activity. Each row in the
 * Global Notes table maps to one (referenceTable, referenceId) anchor.
 */
import { useQuery } from "@tanstack/react-query";

import {
  getNoteEntities,
  NoteEntityListParams,
  PaginatedNoteEntities,
} from "@services/notes";

export const useNoteEntities = (params: NoteEntityListParams) => {
  return useQuery<PaginatedNoteEntities>(
    ["noteEntities", params],
    () => getNoteEntities(params),
    { keepPreviousData: true },
  );
};
